import { Expose, Type } from "class-transformer";
import ShopRes from "types/res/shop/ShopRes";

export default class CosplayRes {
  @Expose() readonly cosplayId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly name!: string;
  @Expose() readonly totalFee!: number;
  @Expose() readonly shopFee!: number;
  @Expose() readonly castFee!: number;
  @Type(() => ShopRes)
  @Expose()
  readonly shops!: ShopRes[];
}
